// extracted by mini-css-extract-plugin
export var animLottie = "sceneWelcome-module--animLottie--iue3Q";
export var big = "sceneWelcome-module--big--vGCka";
export var last = "sceneWelcome-module--last--zHzvL";
export var bubbleLT = "sceneWelcome-module--bubbleLT--+2nhu";
export var bubbleLB = "sceneWelcome-module--bubbleLB--x9q1d";
export var bubbleR = "sceneWelcome-module--bubbleR--hhGkZ";
export var buttonNext = "sceneWelcome-module--buttonNext--Rokpw";
export var buttonStart = "sceneWelcome-module--buttonStart--Js1N2";
export var bubble_2 = "sceneWelcome-module--bubble_2--vF62A";